let lastScrollTop = 0;

window.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", scrolling);
  if (window.location.href.includes("open-cart"))
    document.documentElement.classList.add("cart-drawer");
});

function scrolling() {
  // document.documentElement.classList?.remove("nav-open");
  // let scrollTop = window.scrollY || document.documentElement.scrollTop;
  // window.scrollY > 100 && scrollTop > lastScrollTop
  //   ? document.documentElement.classList.add("scroll-down")
  //   : document.documentElement.classList.remove("scroll-down");
  // lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  // if (window.scrollY > 10) document.documentElement.classList.add("not-top");
  // else document.documentElement.classList.remove("not-top");
}

function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: "smooth",
  });
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;
  currentValue--;
  if (currentValue == 1)
    e.parentNode.querySelector('[onclick^="minQuantity"]').classList.add("off");
  e.parentNode.querySelector("input").value = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
      addModalAndButtonPriceCart();
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

function fetchCartUpdateQty(el, itemId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));
}

window.cartUpdateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartReduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartIncreaseQty = (el) => {
  const maxStock = parseInt(el.getAttribute("max"));
  if (maxStock <= 0) return;

  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  let quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );
  quantity++;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        if (document.querySelector(".product_errors")) {
          el.parentNode.parentNode.parentNode
            .querySelector(".product_errors")
            .classList.remove("hidden");
          el.parentNode.parentNode.parentNode.querySelector(
            ".product_errors_message",
          ).textContent = erreurs;
        }
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  fetchCartUpdateQty(el, itemId, 0);
  return false;
};

function emptyCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
  });
}

window.changeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  // const quantity = parseInt(el.parentNode.querySelector('span').textContent) + 1
  const quantity = el.value;
  console.log(itemId);

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.remove("hidden");
        // el.parentNode.parentNode.parentNode.querySelector(
        //   ".product_errors_message"
        // ).textContent = erreurs;
        console.log(erreurs);
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

// window.emptyCart = () => {
//   fetch("/cart/clear.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       console.log("Panier vidé avec succès", data);
//     })
//     .catch((error) => {
//       console.error("Erreur emptyCart :", error);
//     });
// };

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}

function addToCart(e) {
  e.preventDefault();
  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));

  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key];
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;

  let addToCartAction = () => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        const erreurs = data.errors || data.description;
        if (erreurs) {
          addToCartErrors(erreurs);
          e.target.querySelector('[type="submit"]').disabled = false;
          return false;
        } else {
          hideAddToCartErrors();
        }
        updateCart(data);
        document.documentElement.classList.add("cart-drawer");
        e.target.querySelector('[type="submit"]').disabled = false;
      })
      .catch((error) => {
        if (document.querySelector(".product_errors")) {
          e.target.querySelector(".product_errors").classList.remove("hidden");
          console.error("Erreur :", error);
        }
      });
  };

  addToCartAction();
}

function checkPreco(e) {}
function addToCartErrors(message) {
  document.querySelector(".product_errors").classList.remove("hidden");
  document.querySelector(".product_errors_message").textContent =
    "Veuillez choisir une édition";
  return false;
}

function hideAddToCartErrors() {
  document.querySelector(".product_errors").classList.add("hidden");
}

function faqToggle(element) {
  const body = element.nextElementSibling;
  const maxHeight = body.scrollHeight + "px";

  if (element.parentNode.classList.contains("active")) {
    element.parentNode.classList.remove("active");
    body.style.maxHeight = "0";
  } else {
    if (document.querySelector(".faq_item.active")) {
      document.querySelector(".faq_item.active .faq_body").style.maxHeight =
        "0";
      document.querySelector(".faq_item.active").classList.remove("active");
    }
    element.parentNode.classList.add("active");
    body.style.maxHeight = maxHeight;
  }
}

function toggle(element) {
  const body = element.nextElementSibling;
  const maxHeight = body.scrollHeight + "px";

  if (element.parentNode.classList.contains("active")) {
    element.parentNode.classList.remove("active");
    body.style.maxHeight = "0";
  } else {
    if (document.querySelector(".toggle_item.active")) {
      document.querySelector(
        ".toggle_item.active .toggle_body",
      ).style.maxHeight = "0";
      document.querySelector(".toggle_item.active").classList.remove("active");
    }
    element.parentNode.classList.add("active");
    body.style.maxHeight = maxHeight;
  }
}
